import {ACTION_TYPE, EDITORMODE} from "./constants";

class VersionManager {
  static LATEST_VERSION = "v1.1.1";

  constructor(context) {
    this.context = context;
    this.version = VersionManager.LATEST_VERSION;
    this.parseVersion();
  }

  getVersion() {
    return this.version;
  }

  setVersion(version) {
    if (version === undefined) this.version = "v0.0.0";
    else if (version === "LATEST") this.version = VersionManager.LATEST_VERSION;
    else this.version = version;

    this.parseVersion();
  }

  parseVersion() {
    // version format: "v{MAJOR}.{MINOR}.{PATCH}"
    const vNum = this.version.slice(1);
    const [majorVer, minorVer, patchVer] = vNum.split(".");
    this.majorVer = Number(majorVer);
    this.minorVer = Number(minorVer);
    this.patchVer = Number(patchVer);

    const versionCompatibility = {};
    for (let category in this.checkCompatibility) {
      versionCompatibility[category] = {};
      for (let key in this.checkCompatibility[category]) {
        versionCompatibility[category][key] = this.checkCompatibility[category][key]();
      }
    }
    this.context.dispatchEvent(
      new CustomEvent(ACTION_TYPE.UPDATE_VERSION_INFO, {
        detail: {
          version: this.version,
          versionCompatibility: versionCompatibility,
        },
      }),
    );
  }

  checkCompatibility = {
    script: {
      // use OOP style scripting
      isOOP: () => this.majorVer >= 1 && this.context.codeEditorMode === EDITORMODE.JAVASCRIPT_3D,
      // can write scripts in every objects
      inObject: () => this.majorVer >= 1 && this.context.codeEditorMode === EDITORMODE.JAVASCRIPT_3D,
    },
    avatar: {
      // create avatar by default (avatar & playCamera are dependent)
      isCreatedByDefault: () =>
        (!(this.majorVer >= 1 && this.minorVer >= 1) && this.context.codeEditorMode === EDITORMODE.JAVASCRIPT_3D) ||
        this.context.codeEditorMode === EDITORMODE.BLOCK,
    },
  };
}

export default VersionManager;
